//@flow
import { handleMutationError } from "../API"
import type { CreateKioskMutation, UpdateKioskMutation, Kiosk } from "./types"

const handleSubmit = (
  id: ?string,
  createKiosk: CreateKioskMutation,
  updateKiosk: UpdateKioskMutation,
  onSuccess: Function
) => async (kiosk: Kiosk) => {
  try {
    await (typeof id === "string" ? updateKiosk(id, kiosk) : createKiosk(kiosk))
    onSuccess()
  } catch (mutationError) {
    const errorString: string = mutationError
    handleMutationError(errorString)
  }
}

export default handleSubmit



// WEBPACK FOOTER //
// ./src/Kiosks/handleSubmit.js